/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { SchemaImportDataRequest } from '../../../../types/SchemaImportDataRequest';

export const SchemaImportRequest: core.serialization.Schema<
    serializers.SchemaImportRequest.Raw,
    Truvity.SchemaImportRequest
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: SchemaImportDataRequest,
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace SchemaImportRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data: SchemaImportDataRequest.Raw;
        labels?: Record<string, string> | null;
    }
}
